export default __webpack_public_path__ + "static/media/grateful-calender.b5926087.jpg";